import { render } from "./CMatchingInfo.vue?vue&type=template&id=36e28a56&scoped=true"
const script = {}

import "./CMatchingInfo.vue?vue&type=style&index=0&id=36e28a56&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e28a56"]])

export default __exports__